import { CardType } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

const PROCESSOUT_TO_CARD_TYPE_MAPPING: Record<string, CardType> = {
  debit: CardType.DEBIT,
  credit: CardType.CREDIT,
  prepaid: CardType.PREPAID,
  'deferred debit': CardType.DEFERRED_DEBIT,
  charge: CardType.CHARGE,
}

export const normalizeCardType = (type: string): CardType => {
  return PROCESSOUT_TO_CARD_TYPE_MAPPING[type] ?? CardType.UNKNOWN
}
